// extracted by mini-css-extract-plugin
module.exports = {"slide":"RecommendedProducts_slide__3uMaW","prevArrow":"RecommendedProducts_prevArrow__1aVrR","nextArrow":"RecommendedProducts_nextArrow__R6pri"};